/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceType } from '../models/DeviceType';
import type { PasswordExpiredRequest } from '../models/PasswordExpiredRequest';
import type { ResetPasswordSubmit } from '../models/ResetPasswordSubmit';
import type { TokenInfo } from '../models/TokenInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IdentityService {

  /**
   * @param userId 
   * @param requestBody 
   * @returns TokenInfo Success
   * @throws ApiError
   */
  public static postIdentityUsersPasswordChange(
userId: number,
requestBody?: PasswordExpiredRequest,
): CancelablePromise<TokenInfo> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/identity/users/{userId}/password/change',
      path: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param formData 
   * @returns TokenInfo Success
   * @throws ApiError
   */
  public static postIdentitySignIn(
formData?: {
Login: string;
Password: string;
DeviceType?: DeviceType;
Device?: string;
Location?: string;
},
): CancelablePromise<TokenInfo> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/identity/sign-in',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        401: `Unauthorized`,
      },
    });
  }

  /**
   * @returns TokenInfo Success
   * @throws ApiError
   */
  public static postIdentityLogout(): CancelablePromise<TokenInfo> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/identity/logout',
      errors: {
        401: `Unauthorized`,
      },
    });
  }

  /**
   * @param userCode 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postIdentityUsersPasswordResetInit(
userCode: string,
requestBody?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/identity/users/{userCode}/password/reset/init',
      path: {
        'userCode': userCode,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param userCode 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postIdentityUsersPasswordResetCheck(
userCode: string,
requestBody?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/identity/users/{userCode}/password/reset/check',
      path: {
        'userCode': userCode,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param userCode 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postIdentityUsersPasswordResetSubmit(
userCode: string,
requestBody?: ResetPasswordSubmit,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/identity/users/{userCode}/password/reset/submit',
      path: {
        'userCode': userCode,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param userId 
   * @returns any Success
   * @throws ApiError
   */
  public static postIdentityUsersTwoFactorSend(
userId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/identity/users/{userId}/two-factor/send',
      path: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns TokenInfo Success
   * @throws ApiError
   */
  public static postIdentityUsersTwoFactorSubmit(
userId: number,
requestBody?: string,
): CancelablePromise<TokenInfo> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/identity/users/{userId}/two-factor/submit',
      path: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

}
